export enum CampaignTab {
    campaign = 'campaign',
    campaigndetail = 'campaigndetail',
}

// AMZ Ads will aggregation the day performances of campaign in the end of day.
// And supported 90 days filter (from now)
// So the max date range is 90 - 1 = 89 days
export const MAX_AMZ_ADS_FILTER_DAYS = 90 - 1;